const langText: Record<string, any> = {
    au: {
        discount: 'Discount',
        site_account_profile_firstname: 'First Name',
        site_account_profile_lastname: 'Last Name',
        site_account_address_zip: 'Zip',
        site_account_address_phone: 'Phone',
        product_text: 'Product',
        gift_card: 'Gift Card',
        view_all: 'View all',
        coupon: 'Discount code',
        have_points: 'You have <code>{points} EcoCredits</code>',
        available: 'Available',
        redeemed: 'Redeemed',
        expired: 'Expired',
        spend_now: 'Spend Now',
        store: 'Shop Now',
        no_enough_points: 'Redemption failed, your EcoCredits are not enough',
        no_history_note: 'Don’t see your EcoCredits yet? Your activity will update with in 24 hours.',
        no_coupon_note: 'No rewards redeemed yet.',
        stay_too_long: 'Your session has expired. Please refresh the page and try again.',
        exceeded_counts: 'Failed to redeem. You have exceeded the redemption limit.',
        minimum_num: 'Minimum quantity of items({num} pcs).',
        no_stock_tip: 'Coming soon... Stay tuned!',
        network_error: 'Network Error',
        redeem_ecocredits_title: 'Redeem EcoCredits Rewards',
        redeemed_succ: 'Redeemed successfully!',
        copy_desc: 'You have copied the code, please go to the store to use it.',
        copy_desc_2: 'You have copied the code.',
        rules: 'Rules',
        confirm_text: 'Are you sure you want to redeem? Cannot be undone.',
        confirm_btn: 'Confirm',
        site_rules: 'For AU store only.',
        order_rule: 'Only one discount code per order.',
        purchas_rule: 'Purchasing an item for less than the coupon(s), will forfeit the difference.',
        minimum_price: 'Minimum purchase amount ({price}).',
        days_rules: 'Valid for {days} days from redemption.',
        days_rules2: 'Valid from {data}.',
        campaign_time_limit_text: 'Valid redemption period: {startTime} - {endTime}.',
        email_validation_error: 'Please enter a valid email address.',
        shipping_address_text: 'Shipping address',
        site_account_profile_country: 'Country/Region',
        site_account_profile_country_wrong_tip: 'Please Enter Country',
        site_account_profile_firstname_wrong_tip: 'Invalid first name',
        site_account_address_zip_wrong_tip: 'Invalid zip',
        site_account_profile_username_wrong_tip: 'Invalid username',
        site_account_address_company_website_wrong_tip: 'Invalid company website',
        site_account_address_phone_wrong_tip: 'Invalid phone',
        site_account_address_address_wrong_tip: 'Invalid address',
        site_account_address_company_name_wrong_tip: 'Invalid company name',
        site_account_profile_lastname_wrong_tip: 'Invalid last name',
        site_account_profile_country_select_wrong_tip: 'Please select your country!',
        site_account_address_adress: 'My Address',
        site_account_address_apt: 'Apt, Suite, Building(optional)',
        city_validatino_error: 'Invalid city',
        site_account_address_city: 'City',
        site_account_profile_email: 'Email Address',
        product_rules: 'For {product} only.',
        points: 'EcoCredits',
        redeem_now: 'REDEEM NOW',
        off: 'OFF',
        use_new_address: 'use a new address',
        stock_left: '{stock} Left',
        order_text: 'Order',
        site_account_profile_save_success: 'Success',
        grab_success_text2: 'Check your bonuses in <code>My Rewards</code>.',
        only_plus_member: 'Only PLUS Members can redeem the reward.',
        only_member: 'Only Members can redeem the reward.',
    },
    us: {
        discount: 'Discount',
        site_account_profile_firstname: 'First Name',
        site_account_profile_lastname: 'Last Name',
        site_account_address_zip: 'Zip',
        site_account_address_phone: 'Phone',
        product_text: 'Product',
        gift_card: 'Gift Card',
        view_all: 'View all',
        coupon: 'Discount code',
        have_points: 'You have <code>{points} EcoCredits</code>',
        available: 'Available',
        redeemed: 'Redeemed',
        expired: 'Expired',
        spend_now: 'Spend Now',
        store: 'Shop Now',
        no_enough_points: 'Redemption failed, your EcoCredits are not enough',
        no_history_note: 'Don’t see your EcoCredits yet? Your activity will update with in 24 hours.',
        no_coupon_note: 'No rewards redeemed yet.',
        stay_too_long: 'Your session has expired. Please refresh the page and try again.',
        exceeded_counts: 'Failed to redeem. You have exceeded the redemption limit.',
        minimum_num: 'Minimum quantity of items({num} pcs).',
        no_stock_tip: 'Coming soon... Stay tuned!',
        network_error: 'Network Error',
        redeem_ecocredits_title: 'Redeem EcoCredits Rewards',
        redeemed_succ: 'Redeemed successfully!',
        copy_desc: 'You have copied the code, please go to the store to use it.',
        copy_desc_2: 'You have copied the code.',
        rules: 'Rules',
        confirm_text: 'Are you sure you want to redeem? Cannot be undone.',
        confirm_btn: 'Confirm',
        site_rules: 'For US store only.',
        order_rule: 'Only one discount code per order.',
        purchas_rule: 'Purchasing an item for less than the coupon(s), will forfeit the difference.',
        minimum_price: 'Minimum purchase amount ({price}).',
        days_rules: 'Valid for {days} days from redemption.',
        days_rules2: 'Valid from {data}.',
        campaign_time_limit_text: 'Valid redemption period: {startTime} - {endTime}.',
        email_validation_error: 'Please enter a valid email address.',
        shipping_address_text: 'Shipping address',
        site_account_profile_country: 'Country/Region',
        site_account_profile_country_wrong_tip: 'Please Enter Country',
        site_account_profile_firstname_wrong_tip: 'Invalid first name',
        site_account_address_zip_wrong_tip: 'Invalid zip',
        site_account_profile_username_wrong_tip: 'Invalid username',
        site_account_address_company_website_wrong_tip: 'Invalid company website',
        site_account_address_phone_wrong_tip: 'Invalid phone',
        site_account_address_address_wrong_tip: 'Invalid address',
        site_account_address_company_name_wrong_tip: 'Invalid company name',
        site_account_profile_lastname_wrong_tip: 'Invalid last name',
        site_account_profile_country_select_wrong_tip: 'Please select your country!',
        site_account_address_adress: 'My Address',
        site_account_address_apt: 'Apt, Suite, Building(optional)',
        city_validatino_error: 'Invalid city',
        site_account_address_city: 'City',
        site_account_profile_email: 'Email Address',
        product_rules: 'For {product} only.',
        points: 'EcoCredits',
        redeem_now: 'REDEEM NOW',
        off: 'OFF',
        use_new_address: 'use a new address',
        stock_left: '{stock} Left',
        order_text: 'Order',
        site_account_profile_save_success: 'Success',
        grab_success_text2: 'Check your bonuses in <code>My Rewards</code>.',
        only_plus_member: 'Only PLUS Members can redeem the reward.',
        only_member: 'Only Members can redeem the reward.',
    },
    ca: {
        discount: 'Discount',
        product_text: 'Product',
        site_account_profile_firstname: 'First Name',
        site_account_profile_lastname: 'Last Name',
        site_account_address_zip: 'Zip',
        site_account_address_phone: 'Phone',
        gift_card: 'Gift Card',
        view_all: 'View all',
        coupon: 'Discount code',
        have_points: 'You have <code>{points} EcoCredits</code>',
        available: 'Available',
        redeemed: 'Redeemed',
        expired: 'Expired',
        spend_now: 'Spend Now',
        store: 'Shop Now',
        no_enough_points: 'Redemption failed, your EcoCredits are not enough',
        no_history_note: 'Don’t see your EcoCredits yet? Your activity will update with in 24 hours.',
        no_coupon_note: 'No rewards redeemed yet.',
        stay_too_long: 'Your session has expired. Please refresh the page and try again.',
        exceeded_counts: 'Failed to redeem. You have exceeded the redemption limit.',
        minimum_num: 'Minimum quantity of items({num} pcs).',
        no_stock_tip: 'Coming soon... Stay tuned!',
        network_error: 'Network Error',
        redeem_ecocredits_title: 'Redeem EcoCredits Rewards',
        redeemed_succ: 'Redeemed successfully!',
        copy_desc: 'You have copied the code, please go to the store to use it.',
        copy_desc_2: 'You have copied the code.',
        rules: 'Rules',
        confirm_text: 'Are you sure you want to redeem? Cannot be undone.',
        confirm_btn: 'Confirm',
        site_rules: 'For CA store only.',
        order_rule: 'Only one discount code per order.',
        purchas_rule: 'Purchasing an item for less than the coupon(s), will forfeit the difference.',
        minimum_price: 'Minimum purchase amount ({price}).',
        days_rules: 'Valid for {days} days from redemption.',
        days_rules2: 'Valid from {data}.',
        campaign_time_limit_text: 'Valid redemption period: {startTime} - {endTime}.',
        email_validation_error: 'Please enter a valid email address.',
        shipping_address_text: 'Shipping address',
        site_account_profile_country: 'Country/Region',
        site_account_profile_country_wrong_tip: 'Please Enter Country',
        site_account_profile_firstname_wrong_tip: 'Invalid first name',
        site_account_address_zip_wrong_tip: 'Invalid zip',
        site_account_profile_username_wrong_tip: 'Invalid username',
        site_account_address_company_website_wrong_tip: 'Invalid company website',
        site_account_address_phone_wrong_tip: 'Invalid phone',
        site_account_address_address_wrong_tip: 'Invalid address',
        site_account_address_company_name_wrong_tip: 'Invalid company name',
        site_account_profile_lastname_wrong_tip: 'Invalid last name',
        site_account_profile_country_select_wrong_tip: 'Please select your country!',
        site_account_address_adress: 'My Address',
        site_account_address_apt: 'Apt, Suite, Building(optional)',
        city_validatino_error: 'Invalid city',
        site_account_address_city: 'City',
        site_account_profile_email: 'Email Address',
        product_rules: 'For {product} only.',
        points: 'EcoCredits',
        redeem_now: 'REDEEM NOW',
        off: 'OFF',
        use_new_address: 'use a new address',
        stock_left: '{stock} Left',
        order_text: 'Order',
        site_account_profile_save_success: 'Success',
        grab_success_text2: 'Check your bonuses in <code>My Rewards</code>.',
        only_plus_member: 'Only PLUS Members can redeem the reward.',
        only_member: 'Only Members can redeem the reward.',
    },
    cis: {
        discount: 'Скидка',
        product_text: 'Product',
        site_account_profile_firstname: 'Имя',
        site_account_profile_lastname: 'Фамилия',
        site_account_address_zip: 'Индекс',
        site_account_address_phone: 'Телефон',
        gift_card: 'Подарочная карта',
        view_all: 'Посмотреть все',
        coupons: 'Coupons',
        have_points: 'У вас <code>{points} балл.</code>',
        available: 'Доступно',
        redeemed: 'Обменяно',
        expired: 'Срок действия истек',
        spend_now: 'Spend Now',
        store: 'Магазин',
        no_enough_points: 'Не получилось обменять, баллов пока недостаточно',
        no_history_note: 'Don’t see your EcoCredits yet? Your activity will update with in 24 hours.',
        no_coupon_note: 'Наград пока не получено.',
        stay_too_long: 'Сессия истекла. Обновите страницу и повторите попытку.',
        exceeded_counts: 'Failed to redeem. You have exceeded the redemption limit.',
        minimum_num: 'Минимальное количество предметов ({num} шт.).',
        no_stock_tip: 'Coming soon... Stay tuned!',
        network_error: 'Ошибка сети',
        redeem_ecocredits_title: 'Обменять вознаграждения EcoCredits',
        redeemed_succ: 'Обмен успешно выполнен!',
        copy_desc: 'Код скопирован, теперь вы можете использовать его в магазине.',
        copy_desc_2: 'You have copied the code.',
        rules: 'Rules',
        confirm_text: 'Вы действительно хотите осуществить данную операцию? Ее ​нельзя будет отменить.',
        confirm_btn: 'Подтвердите',
        site_rules: 'Только для магазинов в США.',
        minimum_price: 'Минимальная сумма покупки ({price}).',
        days_rules: 'Действительно {days} дн. с момента обмена',
        days_rules2: 'Действителен с {data}.',
        campaign_time_limit_text: 'Valid redemption period: {startTime} - {endTime}.',
        email_validation_error: 'Please enter a valid email address.',
        shipping_address_text: 'Shipping address',
        site_account_profile_country: 'Country/Region',
        site_account_profile_country_wrong_tip: 'Please Enter Country',
        site_account_profile_firstname_wrong_tip: 'Invalid first name',
        site_account_address_zip_wrong_tip: 'Invalid zip',
        site_account_profile_username_wrong_tip: 'Invalid username',
        site_account_address_company_website_wrong_tip: 'Invalid company website',
        site_account_address_phone_wrong_tip: 'Invalid phone',
        site_account_address_address_wrong_tip: 'Invalid address',
        site_account_address_company_name_wrong_tip: 'Invalid company name',
        site_account_profile_lastname_wrong_tip: 'Invalid last name',
        site_account_profile_country_select_wrong_tip: 'Please select your country!',
        site_account_address_adress: 'My Address',
        site_account_address_apt: 'Apt, Suite, Building(optional)',
        city_validatino_error: 'Invalid city',
        site_account_address_city: 'City',
        site_account_profile_email: 'Email Address',
        product_rules: 'Только для {product}',
        points: 'баллы',
        redeem_now: 'ОБМЕНЯТЬ',
        off: 'ВЫКЛ',
        use_new_address: 'use a new address',
        stock_left: '{stock} Left',
        order_text: 'Order',
        site_account_profile_save_success: 'Success',
        grab_success_text2: 'Check your bonuses in <code>My Rewards</code>.',
        only_plus_member: 'Only PLUS Members can redeem the reward.',
        only_member: 'Only Members can redeem the reward.',
    },
    cn: {
        discount: 'Discount',
        product_text: 'Product',
        site_account_profile_firstname: 'First Name',
        site_account_profile_lastname: 'Last Name',
        site_account_address_zip: 'Zip',
        site_account_address_phone: 'Phone',
        gift_card: 'Gift Card',
        view_all: 'View all',
        coupon: 'Discount code',
        have_points: 'You have <code>{points} EcoCredits</code>',
        available: 'Available',
        redeemed: 'Redeemed',
        expired: 'Expired',
        spend_now: 'Spend Now',
        store: 'Shop Now',
        no_enough_points: 'Redemption failed, your EcoCredits are not enough',
        no_history_note: 'Don’t see your EcoCredits yet? Your activity will update with in 24 hours.',
        no_coupon_note: 'No rewards redeemed yet.',
        stay_too_long: 'Your session has expired. Please refresh the page and try again.',
        exceeded_counts: 'Failed to redeem. You have exceeded the redemption limit.',
        minimum_num: 'Minimum quantity of items({num} pcs).',
        no_stock_tip: 'Coming soon... Stay tuned!',
        network_error: 'Network Error',
        redeem_ecocredits_title: 'Redeem EcoCredits Rewards',
        redeemed_succ: 'Redeemed successfully!',
        copy_desc: 'You have copied the code, please go to the store to use it.',
        copy_desc_2: 'You have copied the code.',
        rules: 'Rules',
        confirm_text: 'Are you sure you want to redeem? Cannot be undone.',
        confirm_btn: 'Confirm',
        site_rules: 'For US store only.',
        order_rule: 'Only one discount code per order.',
        purchas_rule: 'Purchasing an item for less than the coupon(s), will forfeit the difference.',
        minimum_price: 'Minimum purchase amount ({price}).',
        days_rules: 'Valid for {days} days from redemption.',
        days_rules2: 'Valid from {data}.',
        campaign_time_limit_text: 'Valid redemption period: {startTime} - {endTime}.',
        email_validation_error: 'Please enter a valid email address.',
        shipping_address_text: 'Shipping address',
        site_account_profile_country: 'Country/Region',
        site_account_profile_country_wrong_tip: 'Please Enter Country',
        site_account_profile_firstname_wrong_tip: 'Invalid first name',
        site_account_address_zip_wrong_tip: 'Invalid zip',
        site_account_profile_username_wrong_tip: 'Invalid username',
        site_account_address_company_website_wrong_tip: 'Invalid company website',
        site_account_address_phone_wrong_tip: 'Invalid phone',
        site_account_address_address_wrong_tip: 'Invalid address',
        site_account_address_company_name_wrong_tip: 'Invalid company name',
        site_account_profile_lastname_wrong_tip: 'Invalid last name',
        site_account_profile_country_select_wrong_tip: 'Please select your country!',
        site_account_address_adress: 'My Address',
        site_account_address_apt: 'Apt, Suite, Building(optional)',
        city_validatino_error: 'Invalid city',
        site_account_address_city: 'City',
        site_account_profile_email: 'Email Address',
        product_rules: 'For {product} only.',
        points: 'EcoCredits',
        redeem_now: 'REDEEM NOW',
        off: 'OFF',
        use_new_address: 'use a new address',
        stock_left: '{stock} Left',
        order_text: 'Order',
        site_account_profile_save_success: 'Success',
        only_plus_member: 'Only PLUS Members can redeem the reward.',
        only_member: 'Only Members can redeem the reward.',
    },
    de: {
        discount: 'Rabatt',
        product_text: 'Produkt',
        gift_card: 'Geschenkkarte',
        site_account_profile_firstname: 'Vorname',
        site_account_profile_lastname: 'Nachname',
        site_account_address_zip: 'PLZ',
        site_account_address_phone: 'Telefon',
        view_all: 'Alle sehen',
        coupon: 'Coupon',
        have_points: 'Sie haben <code>{points} EcoCredits</code>',
        available: 'Verfügbar',
        redeemed: 'Eingelöst',
        expired: 'Abgelaufen',
        spend_now: 'Jetzt ausgeben',
        store: 'Jetzt kaufen',
        no_enough_points: 'Aufgrund unzureichender EcoCredits ist das Einlösen fehlgeschlagen.',
        no_history_note: 'Ihre EcoCredits werden noch nicht angezeigt? Es kann bis zu 24 Stunden dauern, bis Ihre Aktivität angezeigt wird.',
        no_coupon_note: 'Noch keine Gutscheine eingelöst.',
        stay_too_long: 'Ihre Session ist abgelaufen. Bitte aktualisieren Sie die Seite und versuchen Sie es erneut.',
        exceeded_counts: 'Die Einlösung ist gescheitert. Sie haben das Einlöselimit überschritten.',
        minimum_num: 'Mindestmenge an Artikeln ({num} Stück).',
        no_stock_tip: 'Bald verfügbar... Bleiben Sie dran!',
        network_error: 'Netzwerkfehler',
        redeem_ecocredits_title: 'Prämien erhalten',
        redeemed_succ: 'Das Einlösen war erfolgreich!',
        copy_desc: 'Sie haben den Code kopiert. Sie können jetzt zum Shop gehen und ihn benutzen.',
        copy_desc_2: 'Sie haben den Code kopiert.',
        rules: 'Regeln',
        confirm_text: 'Möchten Sie wirklich einlösen? Dieser Vorgang kann nicht rückgängig gemacht werden.',
        confirm_btn: 'Bestätigen',
        site_rules: 'Nur für DE-Shop.',
        order_rule: 'Für jede Bestellung kann nur ein Gutscheincode verwendet werden.',
        purchas_rule: 'Wenn Sie einen Artikel für weniger als den/die Gutschein(e) kaufen, verfällt der Differenzbetrag.',
        minimum_price: 'Mindestausgaben ({price}).',
        days_rules: 'Gültig für {days} Tage ab Einlösung',
        days_rules2: 'Gültig ab {data}.',
        campaign_time_limit_text: 'Gültiger Einlösungszeitraum:  {startTime} - {endTime}.',
        email_validation_error: 'Bitte geben Sie eine gültige E-Mail Adresse ein.',
        shipping_address_text: 'Lieferadresse',
        site_account_profile_country: 'Land/Region',
        site_account_profile_country_wrong_tip: 'Bitte das Land eingeben',
        site_account_profile_firstname_wrong_tip: 'Ungültiger Vorname',
        site_account_address_zip_wrong_tip: 'Ungültige Postleitzahl',
        site_account_profile_username_wrong_tip: 'Ungültiger Benutzername',
        site_account_address_company_website_wrong_tip: 'Ungültige Unternehmenswebsite',
        site_account_address_phone_wrong_tip: 'Ungültige Telefonnummer',
        site_account_address_address_wrong_tip: 'Ungültige Adresse',
        site_account_address_company_name_wrong_tip: 'Ungültiger Firmenname',
        site_account_profile_lastname_wrong_tip: 'Ungültiger Nachname',
        site_account_profile_country_select_wrong_tip: 'Bitte wählen Sie Ihr Land!',
        site_account_address_adress: 'Meine Adresse',
        site_account_address_apt: 'Wohnung, Stockwerk, Gebäude (optional)',
        city_validatino_error: 'Ungültige Ort',
        site_account_address_city: 'Ort',
        site_account_profile_email: 'E-Mail-Adresse',
        product_rules: 'Nur für {product}',
        points: 'EcoCredits',
        redeem_now: 'JETZT EINLÖSEN',
        off: 'RABATTE',
        use_new_address: 'Eine neue Adresse verwenden',
        stock_left: '{stock} übrig',
        order_text: 'Bestellung',
        site_account_profile_save_success: 'Erfolgreich abgegeben',
        grab_success_text2: 'Prüfen Sie Ihre Belohnungen unter <code>"Meine Belohnungen"</code>.',
        only_plus_member: 'PLUS  Mitglied  EcoCredits Prämie',
        only_member: ' Mitglied  EcoCredits Prämie',
    },
    en: {
        discount: 'Discount',
        product_text: 'Product',
        gift_card: 'Gift Card',
        site_account_profile_firstname: 'First Name',
        site_account_profile_lastname: 'Last Name',
        site_account_address_zip: 'Zip',
        site_account_address_phone: 'Phone',
        view_all: 'View all',
        coupon: 'Discount code',
        have_points: 'You have <code>{points} EcoCredits</code>',
        available: 'Available',
        redeemed: 'Redeemed',
        expired: 'Expired',
        spend_now: 'Spend Now',
        store: 'Shop Now',
        no_enough_points: 'Redemption failed, your EcoCredits are not enough',
        no_history_note: 'Don’t see your EcoCredits yet? Your activity will update with in 24 hours.',
        no_coupon_note: 'No rewards redeemed yet.',
        stay_too_long: 'Your session has expired. Please refresh the page and try again.',
        exceeded_counts: 'Failed to redeem. You have exceeded the redemption limit.',
        minimum_num: 'Minimum quantity of items({num} pcs).',
        no_stock_tip: 'Coming soon... Stay tuned!',
        network_error: 'Network Error',
        redeem_ecocredits_title: 'Redeem EcoCredits Rewards',
        redeemed_succ: 'Redeemed successfully!',
        copy_desc: 'You have copied the code, please go to the store to use it.',
        copy_desc_2: 'You have copied the code.',
        rules: 'Rules',
        confirm_text: 'Are you sure you want to redeem? Cannot be undone.',
        confirm_btn: 'Confirm',
        site_rules: 'For US store only.',
        order_rule: 'Only one discount code per order.',
        purchas_rule: 'Purchasing an item for less than the coupon(s), will forfeit the difference.',
        minimum_price: 'Minimum purchase amount ({price}).',
        days_rules: 'Valid for {days} days from redemption.',
        days_rules2: 'Valid from {data}.',
        campaign_time_limit_text: 'Valid redemption period: {startTime} - {endTime}.',
        email_validation_error: 'Please enter a valid email address.',
        shipping_address_text: 'Shipping address',
        site_account_profile_country: 'Country/Region',
        site_account_profile_country_wrong_tip: 'Please Enter Country',
        site_account_profile_firstname_wrong_tip: 'Invalid first name',
        site_account_address_zip_wrong_tip: 'Invalid zip',
        site_account_profile_username_wrong_tip: 'Invalid username',
        site_account_address_company_website_wrong_tip: 'Invalid company website',
        site_account_address_phone_wrong_tip: 'Invalid phone',
        site_account_address_address_wrong_tip: 'Invalid address',
        site_account_address_company_name_wrong_tip: 'Invalid company name',
        site_account_profile_lastname_wrong_tip: 'Invalid last name',
        site_account_profile_country_select_wrong_tip: 'Please select your country!',
        site_account_address_adress: 'My Address',
        site_account_address_apt: 'Apt, Suite, Building(optional)',
        city_validatino_error: 'Invalid city',
        site_account_address_city: 'City',
        site_account_profile_email: 'Email Address',
        product_rules: 'For {product} only.',
        points: 'EcoCredits',
        redeem_now: 'REDEEM NOW',
        off: 'OFF',
        use_new_address: 'use a new address',
        stock_left: '{stock} Left',
        order_text: 'Order',
        site_account_profile_save_success: 'Success',
        grab_success_text2: 'Check your bonuses in <code>My Rewards</code>.',
        only_plus_member: 'Only PLUS Members can redeem the reward.',
        only_member: 'Only Members can redeem the reward.',
    },
    es: {
        discount: 'Descuento',
        product_text: 'Producto',
        gift_card: 'Tarjeta regalo',
        site_account_profile_firstname: 'Nombre',
        site_account_profile_lastname: 'Apellidos',
        site_account_address_zip: 'Código postal',
        site_account_address_phone: 'Teléfono',
        view_all: 'Ver todo',
        coupon: 'Código de descuento',
        have_points: 'Tienes <code>{points} EcoCredits</code>',
        available: 'Disponible',
        redeemed: 'Canjeadas',
        expired: 'Caducado',
        spend_now: 'Gastar Ahora',
        store: 'Comprar Ahora',
        no_enough_points: 'Error al canjear los EcoCredits. No tienes suficientes EcoCredits',
        no_history_note: '¿Todavía no ves tus EcoCredits? Tu actividad se actualizará en 24 horas.',
        no_coupon_note: 'Todavía no se ha canjeado ninguna recompensa.',
        stay_too_long: 'Tu sesión ha expirado. Por favor, actualiza la página e inténtalo otra vez.',
        exceeded_counts: 'No se puede canjear. Has superado el límite de canje.',
        minimum_num: 'Cantidad mínima de artículos ({num} piezas).',
        no_stock_tip: 'Próximamente... ¡Esté atento!',
        network_error: 'Error de red',
        redeem_ecocredits_title: 'Canjear recompensas',
        redeemed_succ: '¡Canjeados correctamente!',
        copy_desc: 'Has copiado el código; ve a la tienda para usarlo.',
        copy_desc_2: 'Has copiado el código.',
        rules: 'Reglas',
        confirm_text: '¿Seguro que quieres canjear tus EcoCredits? Esta acción no se puede anular.',
        confirm_btn: 'Confirmar',
        site_rules: 'Solo para tienda de España.',
        order_rule: 'Solo un código promocional por pedido.',
        purchas_rule: 'Al comprar un artículo por un precio inferior al del cupón, se perderá la diferencia.',
        minimum_price: 'Monto mínimo de compra ({price}).',
        days_rules: 'Válido durante {days} días desde el canje.',
        days_rules2: 'Válido desde {data}.',
        campaign_time_limit_text: 'Periodo de canje válido: {startTime} - {endTime}.',
        email_validation_error: 'Introduce una dirección de email válida por favor.',
        shipping_address_text: 'Dirección de envío',
        site_account_profile_country: 'País/región',
        site_account_profile_country_wrong_tip: 'Indique su país',
        site_account_profile_firstname_wrong_tip: 'Nombre no válido',
        site_account_address_zip_wrong_tip: 'Código postal no válido',
        site_account_profile_username_wrong_tip: 'Nombre de usuario no válido',
        site_account_address_company_website_wrong_tip: 'Página web de la empresa no válida',
        site_account_address_phone_wrong_tip: 'Teléfono no válido',
        site_account_address_address_wrong_tip: 'Dirección no válida',
        site_account_address_company_name_wrong_tip: 'Nombre de empresa no válido',
        site_account_profile_lastname_wrong_tip: 'Apellidos no válidos',
        site_account_profile_country_select_wrong_tip: '¡Por favor seleccione su país!',
        site_account_address_adress: 'Mi dirección',
        site_account_address_apt: 'Apartamento, suite, edificio(opcional)',
        city_validatino_error: 'Ciudad no válida',
        site_account_address_city: 'Ciudad',
        site_account_profile_email: 'Dirección de correo electrónico',
        product_rules: 'Solo para {product}',
        points: 'EcoCredits',
        redeem_now: 'CANJEAR AHORA',
        off: 'DESCUENTO',
        use_new_address: 'Utiliza una nueva dirección',
        stock_left: '{stock} Restantes',
        order_text: 'Pedido',
        site_account_profile_save_success: 'Enviado con éxito',
        grab_success_text2: 'Consulta tus bonus en <code>Mis Recompensas</code>.',
        only_plus_member: 'Solo los Miembros PLUS pueden canjear la recompensa.',
        only_member: 'Solo los Miembros pueden canjear la recompensa.',
    },
    eu: {
        discount: 'Discount',
        product_text: 'Product',
        gift_card: 'Gift Card',
        site_account_profile_firstname: 'First Name',
        site_account_profile_lastname: 'Last Name',
        site_account_address_zip: 'Zip',
        site_account_address_phone: 'Phone',
        view_all: 'View all',
        coupon: 'Discount code',
        have_points: 'You have <code>{points} EcoCredits</code>',
        available: 'Available',
        redeemed: 'Redeemed',
        expired: 'Expired',
        spend_now: 'Spend Now',
        store: 'Shop Now',
        no_enough_points: 'Redemption failed, your EcoCredits are not enough',
        no_history_note: 'Don’t see your EcoCredits yet? Your activity will update with in 24 hours.',
        no_coupon_note: 'No rewards redeemed yet.',
        stay_too_long: 'Your session has expired. Please refresh the page and try again.',
        exceeded_counts: 'Failed to redeem. You have exceeded the redemption limit.',
        minimum_num: 'Minimum quantity of items({num} pcs).',
        no_stock_tip: 'Coming soon... Stay tuned!',
        network_error: 'Network Error',
        redeem_ecocredits_title: 'Redeem Rewards',
        redeemed_succ: 'Redeemed successfully!',
        copy_desc: 'You have copied the code, please go to the store to use it.',
        copy_desc_2: 'You have copied the code.',
        rules: 'Rules',
        confirm_text: 'Are you sure you want to redeem? Cannot be undone.',
        confirm_btn: 'Confirm',
        site_rules: 'For EU store only.',
        order_rule: 'Only one discount code per order.',
        purchas_rule: 'Purchasing an item for less than the coupon(s), will forfeit the difference.',
        minimum_price: 'Minimum purchase amount ({price}).',
        days_rules: 'Valid for {days} days from redemption.',
        days_rules2: 'Valid from {data}.',
        campaign_time_limit_text: 'Valid redemption period: {startTime} - {endTime}.',
        email_validation_error: 'Please enter a valid email address.',
        shipping_address_text: 'Shipping address',
        site_account_profile_country: 'Country/Region',
        site_account_profile_country_wrong_tip: 'Please Enter Country',
        site_account_profile_firstname_wrong_tip: 'Invalid first name',
        site_account_address_zip_wrong_tip: 'Invalid zip',
        site_account_profile_username_wrong_tip: 'Invalid username',
        site_account_address_company_website_wrong_tip: 'Invalid company website',
        site_account_address_phone_wrong_tip: 'Invalid phone',
        site_account_address_address_wrong_tip: 'Invalid address',
        site_account_address_company_name_wrong_tip: 'Invalid company name',
        site_account_profile_lastname_wrong_tip: 'Invalid last name',
        site_account_profile_country_select_wrong_tip: 'Please select your country!',
        site_account_address_adress: 'My Address',
        site_account_address_apt: 'Apt, Suite, Building(optional)',
        city_validatino_error: 'Invalid city',
        site_account_address_city: 'City',
        site_account_profile_email: 'Email Address',
        product_rules: 'For {product} only.',
        points: 'EcoCredits',
        redeem_now: 'REDEEM NOW',
        off: 'OFF',
        use_new_address: 'use a new address',
        stock_left: '{stock} Left',
        order_text: 'Order',
        site_account_profile_save_success: 'Success',
        grab_success_text2: 'Check your bonuses in <code>My Rewards</code>.',
        only_plus_member: 'Only PLUS Members can redeem the reward.',
        only_member: 'Only Members can redeem the reward.',
    },
    fr: {
        discount: 'Réduction',
        product_text: 'Produit',
        gift_card: 'Carte-cadeau',
        site_account_profile_firstname: 'Prénom',
        site_account_profile_lastname: 'Nom de famille',
        site_account_address_zip: 'Code postal',
        site_account_address_phone: 'Numéro de téléphone',
        view_all: 'Voir tout',
        coupon: 'Code de réduction',
        have_points: 'Vous avez <code>{points} EcoCredits</code>',
        available: 'Disponible',
        redeemed: 'Échangées',
        expired: 'Arrivé à expiration',
        spend_now: 'Utiliser maintenant',
        store: 'Acheter maintenant',
        no_enough_points: "Échec de l'échange, vos EcoCredits ne sont pas suffisants",
        no_history_note: 'Vous ne voyez pas encore vos EcoCredits ? Votre activité sera mise à jour dans les 24 heures.',
        no_coupon_note: 'Aucune récompense échangée pour le moment.',
        stay_too_long: 'Votre session a expiré. Veuillez actualiser la page et réessayer.',
        exceeded_counts: "Echec de l'échange. Vous avez dépassé la limite d'échanges.",
        minimum_num: "Quantité minimum d'articles ({num} articles).",
        no_stock_tip: "Bientôt disponible...Restez à l'écoute !",
        network_error: 'Erreur réseau',
        redeem_ecocredits_title: 'Échanger mes points',
        redeemed_succ: 'Échangées avec succès !',
        copy_desc: "Vous avez copié le code, veuillez vous rendre en boutique pour l'utiliser.",
        copy_desc_2: 'Vous avez copié le code.',
        rules: 'Règles',
        confirm_text: "Voulez-vous vraiment procéder à l'échange ? Vous ne pouvez pas annuler cette action.",
        confirm_btn: 'Confirmer',
        site_rules: 'Réservé aux clients de la boutique française.',
        order_rule: 'Un seul code promo par commande.',
        purchas_rule: "Si le prix de l'article est inférieur à la valeur du/des code(s) promo, la différence sera perdue.",
        minimum_price: "Montant minimum d'achat ({price}).",
        days_rules: "Valable pendant {days} jours à partir de la date d'échange",
        days_rules2: 'Valable à partir de {data}.',
        campaign_time_limit_text: 'Période de remboursement valide: {startTime} - {endTime}.',
        email_validation_error: 'Veuillez saisir une adresse e-mail valide.',
        shipping_address_text: 'Adresse de livraison',
        site_account_profile_country: 'Pays/région',
        site_account_profile_country_wrong_tip: 'Veuillez indiquer votre pays.',
        site_account_profile_firstname_wrong_tip: 'Prénom non valide',
        site_account_address_zip_wrong_tip: 'Code postal non valide',
        site_account_profile_username_wrong_tip: "Nom d'utilisateur non valide",
        site_account_address_company_website_wrong_tip: "Site Web de l'entreprise non valide",
        site_account_address_phone_wrong_tip: 'Téléphone non valide',
        site_account_address_address_wrong_tip: 'Adresse non valide',
        site_account_address_company_name_wrong_tip: "Nom de l'entreprise non valide",
        site_account_profile_lastname_wrong_tip: 'Nom de famille non valide',
        site_account_profile_country_select_wrong_tip: 'Veuillez choisissez votre pays!',
        site_account_address_adress: 'Mon adresse',
        site_account_address_apt: 'Appartement, suite, bâtiment (facultatif)',
        city_validatino_error: 'Ville non valide',
        site_account_address_city: 'Ville',
        site_account_profile_email: 'Adresse e-mail',
        product_rules: 'Pour {product} seulement',
        points: 'EcoCredits',
        redeem_now: 'ÉCHANGER MAINTENANT',
        off: 'OFF',
        use_new_address: 'Utiliser une nouvelle adresse',
        stock_left: '{stock} restants',
        order_text: 'Commande',
        site_account_profile_save_success: 'Enregistré',
        grab_success_text2: 'Consultez vos bonus dans l\'espace <code>"Mes récompenses"</code>.',
        only_plus_member: 'Seuls les membres PLUS peuvent accéder à cette récompense.',
        only_member: 'Seuls les membres peuvent accéder à cette récompense.',
    },
    hk: {
        discount: 'Discount',
        product_text: 'Product',
        gift_card: 'Gift Card',
        site_account_profile_firstname: 'First Name',
        site_account_profile_lastname: 'Last Name',
        site_account_address_zip: 'Zip',
        site_account_address_phone: 'Phone',
        view_all: 'View all',
        coupon: 'Discount code',
        have_points: 'You have <code>{points} EcoCredits</code>',
        available: 'Available',
        redeemed: 'Redeemed',
        expired: 'Expired',
        spend_now: 'Spend Now',
        store: 'Shop Now',
        no_enough_points: 'Redemption failed, your EcoCredits are not enough',
        no_history_note: 'Don’t see your EcoCredits yet? Your activity will update with in 24 hours.',
        no_coupon_note: 'No rewards redeemed yet.',
        stay_too_long: 'Your session has expired. Please refresh the page and try again.',
        exceeded_counts: 'Failed to redeem. You have exceeded the redemption limit.',
        minimum_num: 'Minimum quantity of items({num} pcs).',
        no_stock_tip: 'Coming soon... Stay tuned!',
        network_error: 'Network Error',
        redeem_ecocredits_title: 'Redeem EcoCredits Rewards',
        redeemed_succ: 'Redeemed successfully!',
        copy_desc: 'You have copied the code, please go to the store to use it.',
        copy_desc_2: 'You have copied the code.',
        rules: 'Rules',
        confirm_text: 'Are you sure you want to redeem? Cannot be undone.',
        confirm_btn: 'Confirm',
        site_rules: 'For HK store only.',
        order_rule: 'Only one discount code per order.',
        purchas_rule: 'Purchasing an item for less than the coupon(s), will forfeit the difference.',
        minimum_price: 'Minimum purchase amount ({price}).',
        days_rules: 'Valid for {days} days from redemption.',
        days_rules2: 'Valid from {data}.',
        campaign_time_limit_text: 'Valid redemption period: {startTime} - {endTime}.',
        email_validation_error: 'Please enter a valid email address.',
        shipping_address_text: 'Shipping address',
        site_account_profile_country: 'Country/Region',
        site_account_profile_country_wrong_tip: 'Please Enter Country',
        site_account_profile_firstname_wrong_tip: 'Invalid first name',
        site_account_address_zip_wrong_tip: 'Invalid zip',
        site_account_profile_username_wrong_tip: 'Invalid username',
        site_account_address_company_website_wrong_tip: 'Invalid company website',
        site_account_address_phone_wrong_tip: 'Invalid phone',
        site_account_address_address_wrong_tip: 'Invalid address',
        site_account_address_company_name_wrong_tip: 'Invalid company name',
        site_account_profile_lastname_wrong_tip: 'Invalid last name',
        site_account_profile_country_select_wrong_tip: 'Please select your country!',
        site_account_address_adress: 'My Address',
        site_account_address_apt: 'Apt, Suite, Building(optional)',
        city_validatino_error: 'Invalid city',
        site_account_address_city: 'City',
        site_account_profile_email: 'Email Address',
        product_rules: 'For {product} only.',
        points: 'EcoCredits',
        redeem_now: 'REDEEM NOW',
        off: 'OFF',
        use_new_address: 'use a new address',
        stock_left: '{stock} Left',
        order_text: 'Order',
        site_account_profile_save_success: 'Success',
        only_plus_member: 'Only PLUS Members can redeem the reward.',
        only_member: 'Only Members can redeem the reward.',
    },
    it: {
        discount: 'Sconto',
        product_text: 'Prodotto',
        gift_card: 'Buono regalo',
        site_account_profile_firstname: 'Nome',
        site_account_profile_lastname: 'Cognome',
        site_account_address_zip: 'CAP',
        site_account_address_phone: 'Telefono',
        view_all: 'Visualizza tutti',
        coupon: 'Codice di sconto',
        have_points: 'Hai <code>{points} EcoCredits</code>',
        available: 'Disponibili',
        redeemed: 'Riscattate',
        expired: 'Scaduti',
        spend_now: 'Spendi ora',
        store: 'Acquista ora',
        no_enough_points: 'Riscossione non riuscita, non hai abbastanza EcoCredits',
        no_history_note: 'Non vedi ancora i tuoi EcoCredits? La tua attività verrà aggiornata entro le 24 ore.',
        no_coupon_note: 'Nessun premio riscattato ancora.',
        stay_too_long: 'La tua sessione è scaduta. Si prega di ricaricare la pagina e riprovare.',
        exceeded_counts: 'Non è stato possibile riscattare. È stato superato il limite di riscatto.',
        minimum_num: 'Quantità minima di articoli ({num} pezzi).',
        no_stock_tip: 'Prossimamente... Rimani sintonizzato',
        network_error: 'Errore di rete',
        redeem_ecocredits_title: 'Riscatta i premi',
        redeemed_succ: 'Riscattato correttamente!',
        copy_desc: 'Hai copiato il codice, vai nel negozio per utilizzarlo.',
        copy_desc_2: 'Hai copiato il codice.',
        rules: 'Regole',
        confirm_text: 'Riscattare i EcoCredits? Questa azione non può essere annullata.',
        confirm_btn: 'Conferma',
        site_rules: 'Solo per il negozio italiana.',
        order_rule: "Un solo codice sconto per un'ordine.",
        purchas_rule: "Se il costo dell'articolo è inferiore dei coupon, la differenza andrà persa.",
        minimum_price: 'Importo minimo di acquisto ({price}).',
        days_rules: 'Valido per {days} giorni dal riscatto',
        days_rules2: 'Valido dal {data}.',
        campaign_time_limit_text: 'Periodo di riscatto valido: {startTime} - {endTime}.',
        email_validation_error: 'Si prega di inserire un indirizzo email valido.',
        shipping_address_text: "L'indirizzo di spedizione",
        site_account_profile_country: 'Paese/Regione',
        site_account_profile_country_wrong_tip: 'Indica il tuo paese.',
        site_account_profile_firstname_wrong_tip: 'Nome non valido',
        site_account_address_zip_wrong_tip: 'CAP non valido',
        site_account_profile_username_wrong_tip: 'Nome utente non valido',
        site_account_address_company_website_wrong_tip: "Sito Web dell'azienda non valido",
        site_account_address_phone_wrong_tip: 'Telefono non valido',
        site_account_address_address_wrong_tip: 'Indirizzo non valido',
        site_account_address_company_name_wrong_tip: 'Ragione sociale non valida',
        site_account_profile_lastname_wrong_tip: 'Cognome non valido',
        site_account_profile_country_select_wrong_tip: 'Selezionare il proprio paese!',
        site_account_address_adress: 'Il mio indirizzo',
        site_account_address_apt: 'Appartamento, interno, edificio(opzionale)',
        city_validatino_error: 'Città non valido',
        site_account_address_city: 'Città',
        site_account_profile_email: 'Indirizzo e-mail',
        product_rules: 'Solo per {product}',
        points: 'EcoCredits',
        redeem_now: 'RISCATTA ORA',
        off: 'OFF',
        use_new_address: 'Utilizza un nuovo indirizzo',
        stock_left: '{stock} Rimasti',
        order_text: 'Ordine',
        site_account_profile_save_success: 'Inviata con successo',
        grab_success_text2: 'Controlla i tuoi bonus in <code>I miei premi</code>.',
        only_plus_member: 'Il premio può essere riscattato solo dai clienti PLUS.',
        only_member: 'Il premio può essere riscattato solo dai clienti.',
    },
    jp: {
        discount: 'ディスカウント',
        product_text: 'アイテム',
        gift_card: 'ギフトカード',
        site_account_profile_firstname: '名',
        site_account_profile_lastname: '姓',
        site_account_address_zip: '郵便番号',
        site_account_address_phone: '電話番号',
        view_all: 'すべて表示',
        coupon: 'ディスカウントコード',
        have_points: '<code>{points}ポイント</code>があります',
        available: '使用可能',
        redeemed: '交換が成功しました！',
        expired: '期限切れ',
        spend_now: 'ポイントを使用',
        store: '今すぐ購入',
        no_enough_points: 'ポイントが不足しているため、交換に失敗しました',
        no_history_note: 'ま⁠だ⁠ポ⁠イ⁠ン⁠ト⁠が⁠表⁠示⁠さ⁠れ⁠な⁠い⁠場⁠合⁠も⁠あ⁠り⁠ま⁠す⁠が、ア⁠ク⁠テ⁠ィ⁠ビ⁠テ⁠ィ⁠は24時⁠間⁠以⁠内⁠に⁠更⁠新⁠さ⁠れ⁠ま⁠す。',
        no_coupon_note: 'まだ交換済みの特典はありません。',
        stay_too_long: 'ページに止まる時間が長くて切れました。ページを更新してから確認してください。',
        exceeded_counts: '利用限度額を超えているため、交換できません。',
        minimum_num: '*最低購入個数以上 ({num} 個) の購入時に使用可能です。',
        no_stock_tip: '在庫切れ',
        network_error: 'ネットワークエラー',
        redeem_ecocredits_title: 'エコポイントを特典と交換する',
        redeemed_succ: '交換が成功しました！',
        copy_desc: 'コードをコピーしました。ストアにアクセスして使用してください。',
        copy_desc_2: 'コードをコピーしました',
        rules: '条件',
        confirm_text: '本当に交換をしますか？一度交換した特典を取り消すことはできません。',
        confirm_btn: '確認',
        site_rules: '*EcoFlow Japan公式サイトのストアでのみ適用します。',
        order_rule: '*割引コードは、1回の注文につき1つしか利用することができません。',
        purchas_rule: '*クーポンの値引き額が商品金額を上回っていた場合、差額分は返金されません。',
        minimum_price: '*最低購入金額 ({price})。',
        days_rules: '*交換後の有効期間は{data}です。',
        days_rules2: '*交換後の有効期間は{data}です。',
        campaign_time_limit_text: '交換有効期間：{startTime} - {endTime}.',
        email_validation_error: '有効なメールアドレスを入力してください。',
        shipping_address_text: 'お届け先',
        site_account_profile_country: '国/地域',
        site_account_profile_country_wrong_tip: 'お住まいの国または地域を入力してください。',
        site_account_profile_firstname_wrong_tip: '名が無効です',
        site_account_address_zip_wrong_tip: '郵便番号が無効です',
        site_account_profile_username_wrong_tip: 'ユーザー名が無効です',
        site_account_address_company_website_wrong_tip: '会社の Web サイトが無効です',
        site_account_address_phone_wrong_tip: '電話番号が無効です',
        site_account_address_address_wrong_tip: '所在地が無効です',
        site_account_address_company_name_wrong_tip: '会社名が無効です',
        site_account_profile_lastname_wrong_tip: '姓が無効です',
        site_account_profile_country_select_wrong_tip: '国を選択してください',
        site_account_address_adress: 'お届け先',
        site_account_address_apt: '建物名（非必要事項です）',
        city_validatino_error: '市区町村無効です',
        site_account_address_city: '市区町村',
        site_account_profile_email: 'メールアドレス',
        product_rules: '*{product}のみ対象です。',
        points: 'ポイント',
        redeem_now: '今すぐ交換',
        off: 'OFF',
        use_new_address: '新しい住所を使用',
        stock_left: '残り{stock}個/台',
        order_text: '注文',
        site_account_profile_save_success: '提出は完了しました',
        grab_success_text2: 'あなたが獲得した特典は<code>「交換済みの特典」</code>で確認できます。',
        only_plus_member: 'こちらの特典は、Plus会員の方のみご利用いただけます。',
        only_member: 'こちらの特典は、会員の方のみご利用いただけます。',
    },
    kr: {
        discount: '할인',
        product_text: '제품',
        gift_card: '기프트 카드',
        site_account_profile_firstname: '이름',
        site_account_profile_lastname: '성',
        site_account_address_zip: '우편번호',
        site_account_address_phone: '전화',
        view_all: '더 알아보기',
        coupon: '할인 쿠폰',
        have_points: '에코 포인트: <code> {points} P</code>',
        available: '사용 가능',
        redeemed: '사용됨',
        expired: '만료됨',
        spend_now: '바로 사용하기',
        store: '바로 구매',
        no_enough_points: '사용하지 못했습니다. 포인트가 충분하지 않습니다.',
        no_history_note: '아직 포인트를 확인하지 못하셨나요? 활동이 24시간 이내에 업데이트됩니다.',
        no_coupon_note: '포인트 사용 내역이 없습니다.',
        stay_too_long: '오랜 기간 사용하지 않아 기간이 만료되었습니다. 페이지를 새로 고친 후 다시 시도하십시오.',
        exceeded_counts: '포인트 전환할 수 없습니다. 전환 한도를 초과했습니다.',
        minimum_num: '최소 품목 수량({num} 개).',
        no_stock_tip: '곧 재입고될 예정입니다.',
        network_error: '네트워크 오류',
        redeem_ecocredits_title: '에코 포인트 전환하기',
        redeemed_succ: '성공적으로 사용했습니다!',
        copy_desc: '코드를 복사​했습니다. 코드를 사용하려면 스토어로 이동​하세요.',
        copy_desc_2: '할인 코드를 복사하였습니다.',
        rules: 'Rules',
        confirm_text: '포인트를 사용하시겠습니까?\n사용하면 취소할 수 없습니다.',
        confirm_btn: '확인',
        site_rules: '에코플로우 코리아 공식 홈페이지에서만 적용 가능.',
        order_rule: '할인코드의 중복적용은 불가능합니다.',
        purchas_rule: '쿠폰 금액보다 적은 금액으로 상품을 구매하는 경우,\n 차액이 회수됩니다.',
        minimum_price: '최소 구매 금액 ({price}).',
        days_rules: '리워드 사용일로부터 {days}일 동안 유효.',
        days_rules2: '{data}부터 유효.',
        campaign_time_limit_text: '포인트 전환의 유효 기간: {startTime} - {endTime}.',
        email_validation_error: '유효 메일 주소를 기입해주세요.',
        shipping_address_text: '배송 주소',
        site_account_profile_country: '국가/지역',
        site_account_profile_country_wrong_tip: '국가를 입력하세요',
        site_account_profile_firstname_wrong_tip: '유효하지 않은 이름',
        site_account_address_zip_wrong_tip: '유효하지 않은 우편번호',
        site_account_profile_username_wrong_tip: '유효하지 않은 사용자 이름',
        site_account_address_company_website_wrong_tip: '유효하지 않은 회사 웹사이트',
        site_account_address_phone_wrong_tip: '유효하지 않은 전화번호',
        site_account_address_address_wrong_tip: '유효하지 않은 주소',
        site_account_address_company_name_wrong_tip: '유효하지 않은 회사 이름',
        site_account_profile_lastname_wrong_tip: '유효하지 않은 성',
        site_account_profile_country_select_wrong_tip: '국가 및 지역을 선택하세요',
        site_account_address_adress: '내 주소',
        site_account_address_apt: '아파트, 동, 건물명(선택 사항)',
        city_validatino_error: '유효하지 않은 도시',
        site_account_address_city: '도시',
        site_account_profile_email: '이메일 주소',
        product_rules: '{product} 상품에만 해당',
        points: '포인트',
        redeem_now: '바로 사용하기',
        off: '할인',
        use_new_address: '새 주소를 사용하기',
        stock_left: '{stock}개가 남았습니다.',
        order_text: '주문 번호',
        site_account_profile_save_success: '성공',
        grab_success_text2: '<code>보너스 에코포인트</code> 확인하기',
        only_plus_member: 'PLUS 회원만 리워드를 사용할 수 있습니다.',
        only_member: '회원만 리워드를 사용할 수 있습니다.',
    },
    sa: {
        discount: 'خصم',
        product_text: 'Product',
        gift_card: 'بطاقة هدية"',
        site_account_profile_firstname: 'الاسم الأول',
        site_account_profile_lastname: 'الاسم الأخير',
        site_account_address_zip: 'ملف مضغوط',
        site_account_address_phone: 'رقم الهاتف',
        view_all: 'عرض الكل"',
        coupon: 'رمز الخصم',
        have_points: 'لديك <code>{points} من النقاط</code>',
        available: 'متاح',
        redeemed: 'تم الحصول عليها',
        expired: 'منتهي الصلاحية',
        spend_now: 'Spend Now',
        store: 'تسوق الآن',
        no_enough_points: 'لم ينجح الاستبدال، فنقاطك غير كافية',
        no_history_note: 'ألم ترَ النقاط التي كسبتها بعد؟ سيتم تحديث نشاطك خلال 24 ساعة.',
        no_coupon_note: 'لم يتم الحصول على جوائز بعد.',
        stay_too_long: 'انتهت صلاحية جلستك. يُرجى تحديث الصفحة والمحاولة مرة أخرى.',
        exceeded_counts: 'فشل في استخدام النقاط. لقد تجاوزت حد استخدام النقاط.',
        minimum_num: 'الحد الأدنى لعدد العناصر ({num} من القطع).',
        no_stock_tip: 'Coming soon... Stay tuned!',
        network_error: 'خطأ في الشبكة',
        redeem_ecocredits_title: 'استبدال مكافآت EcoCredits',
        redeemed_succ: 'تم الحصول بنجاح!',
        copy_desc: 'لقد نسخت الرمز. يُرجى الانتقال إلى المتجر لاستخدامه.',
        copy_desc_2: 'You have copied the code.',
        rules: 'Rules',
        confirm_text: 'هل أنت واثق بأنك تريد الاستبدال؟ هذه الخطوة لا يمكن الرجوع فيها.',
        confirm_btn: 'تأكيد',
        site_rules: 'لمتاجر المملكة المتحدة فقط.',
        order_rule: 'رمز خصم واحد فقط لكل طلب.',
        purchas_rule: 'شراء منتج بثمن أقل من قيمة الكوبون (الكوبونات) سيجعلك تفقد باقي قيمة الكوبون.',
        minimum_price: 'الحد الأدنى لمبلغ الشراء ({price}).',
        days_rules: 'يمكن استخدامها خلال {days} من الأيام عند الاستبدال.',
        days_rules2: 'صالح من {data}.',
        campaign_time_limit_text: 'Valid redemption period: {startTime} - {endTime}.',
        email_validation_error: 'يُرجى إدخال عنوان بريد إلكتروني صالح.',
        shipping_address_text: 'Shipping address',
        site_account_profile_country: 'البلد/المنطقة',
        site_account_profile_country_wrong_tip: 'يُرجى إدخال بلد',
        site_account_profile_firstname_wrong_tip: 'الاسم الأول غير صحيح',
        site_account_address_zip_wrong_tip: 'ملف مضغوط غير صالح',
        site_account_profile_username_wrong_tip: 'اسم مستخدم غير صالح',
        site_account_address_company_website_wrong_tip: 'الموقع الإلكتروني للشركة غير صحيح',
        site_account_address_phone_wrong_tip: 'رقم الهاتف غير صحيح',
        site_account_address_address_wrong_tip: 'عنوان غير صالح',
        site_account_address_company_name_wrong_tip: 'اسم الشركة غير صحيح',
        site_account_profile_lastname_wrong_tip: 'الاسم الأخير غير صالح',
        site_account_profile_country_select_wrong_tip: 'الرجاء تحديد البلد',
        site_account_address_adress: 'عنواني',
        site_account_address_apt: 'شقة، جناح، مبنى (اختياري)',
        city_validatino_error: 'Invalid city',
        site_account_address_city: 'المدينة',
        site_account_profile_email: 'عنوان البريد الإلكتروني',
        product_rules: 'لمنتج {product} فقط.',
        points: 'النقاط',
        redeem_now: 'استبدل الآن',
        off: 'إيقاف التشغيل',
        use_new_address: 'use a new address',
        stock_left: '{stock} Left',
        order_text: 'Order',
        site_account_profile_save_success: 'Success',
        only_plus_member: 'Only PLUS Members can redeem the reward.',
        only_member: 'Only Members can redeem the reward.',
    },
    tw: {
        discount: 'Discount',
        product_text: 'Product',
        gift_card: 'Gift Card',
        site_account_profile_firstname: 'First Name',
        site_account_profile_lastname: 'Last Name',
        site_account_address_zip: 'Zip',
        site_account_address_phone: 'Phone',
        view_all: 'View all',
        coupon: 'Discount code',
        have_points: 'You have <code>{points} EcoCredits</code>',
        available: 'Available',
        redeemed: 'Redeemed',
        expired: 'Expired',
        spend_now: 'Spend Now',
        store: 'Shop Now',
        no_enough_points: 'Redemption failed, your EcoCredits are not enough',
        no_history_note: 'Don’t see your EcoCredits yet? Your activity will update with in 24 hours.',
        no_coupon_note: 'No rewards redeemed yet.',
        stay_too_long: 'Your session has expired. Please refresh the page and try again.',
        exceeded_counts: 'Failed to redeem. You have exceeded the redemption limit.',
        minimum_num: 'Minimum quantity of items({num} pcs).',
        no_stock_tip: 'Coming soon... Stay tuned!',
        network_error: 'Network Error',
        redeem_ecocredits_title: 'Redeem EcoCredits Rewards',
        redeemed_succ: 'Redeemed successfully!',
        copy_desc: 'You have copied the code, please go to the store to use it.',
        copy_desc_2: 'You have copied the code.',
        rules: 'Rules',
        confirm_text: 'Are you sure you want to redeem? Cannot be undone.',
        confirm_btn: 'Confirm',
        site_rules: 'For TW store only.',
        order_rule: 'Only one discount code per order.',
        purchas_rule: 'Purchasing an item for less than the coupon(s), will forfeit the difference.',
        minimum_price: 'Minimum purchase amount ({price}).',
        days_rules: 'Valid for {days} days from redemption.',
        days_rules2: 'Valid from {data}.',
        campaign_time_limit_text: 'Valid redemption period: {startTime} - {endTime}.',
        email_validation_error: 'Please enter a valid email address.',
        shipping_address_text: 'Shipping address',
        site_account_profile_country: 'Country/Region',
        site_account_profile_country_wrong_tip: 'Please Enter Country',
        site_account_profile_firstname_wrong_tip: 'Invalid first name',
        site_account_address_zip_wrong_tip: 'Invalid zip',
        site_account_profile_username_wrong_tip: 'Invalid username',
        site_account_address_company_website_wrong_tip: 'Invalid company website',
        site_account_address_phone_wrong_tip: 'Invalid phone',
        site_account_address_address_wrong_tip: 'Invalid address',
        site_account_address_company_name_wrong_tip: 'Invalid company name',
        site_account_profile_lastname_wrong_tip: 'Invalid last name',
        site_account_profile_country_select_wrong_tip: 'Please select your country!',
        site_account_address_adress: 'My Address',
        site_account_address_apt: 'Apt, Suite, Building(optional)',
        city_validatino_error: 'Invalid city',
        site_account_address_city: 'City',
        site_account_profile_email: 'Email Address',
        product_rules: 'For {product} only.',
        points: 'EcoCredits',
        redeem_now: 'REDEEM NOW',
        off: 'OFF',
        use_new_address: 'use a new address',
        stock_left: '{stock} Left',
        order_text: 'Order',
        site_account_profile_save_success: 'Success',
        grab_success_text2: 'Check your bonuses in <code>My Rewards</code>.',
        only_plus_member: 'Only PLUS Members can redeem the reward.',
        only_member: 'Only Members can redeem the reward.',
    },
    uk: {
        discount: 'Discount',
        product_text: 'Product',
        gift_card: 'Gift Card',
        site_account_profile_firstname: 'First Name',
        site_account_profile_lastname: 'Last Name',
        site_account_address_zip: 'Zip',
        site_account_address_phone: 'Phone',
        view_all: 'View all',
        coupon: 'Discount code',
        have_points: 'You have <code>{points} EcoCredits</code>',
        available: 'Available',
        redeemed: 'Redeemed',
        expired: 'Expired',
        spend_now: 'Spend Now',
        store: 'Shop Now',
        no_enough_points: 'Redemption failed, your EcoCredits are not enough',
        no_history_note: 'Don’t see your EcoCredits yet? Your activity will update with in 24 hours.',
        no_coupon_note: 'No rewards redeemed yet.',
        stay_too_long: 'Your session has expired. Please refresh the page and try again.',
        exceeded_counts: 'Failed to redeem. You have exceeded the redemption limit.',
        minimum_num: 'Minimum quantity of items({num} pcs).',
        no_stock_tip: 'Coming soon... Stay tuned!',
        network_error: 'Network Error',
        redeem_ecocredits_title: 'Redeem Rewards',
        redeemed_succ: 'Redeemed successfully!',
        copy_desc: 'You have copied the code, please go to the store to use it.',
        copy_desc_2: 'You have copied the code.',
        rules: 'Rules',
        confirm_text: 'Are you sure you want to redeem? Cannot be undone.',
        confirm_btn: 'Confirm',
        site_rules: 'For UK store only.',
        order_rule: 'Only one discount code per order.',
        purchas_rule: 'Purchasing an item for less than the coupon(s), will forfeit the difference.',
        minimum_price: 'Minimum purchase amount ({price}).',
        days_rules: 'Valid for {days} days from redemption.',
        days_rules2: 'Valid from {data}.',
        campaign_time_limit_text: 'Valid redemption period: {startTime} - {endTime}.',
        email_validation_error: 'Please enter a valid email address.',
        shipping_address_text: 'Shipping address',
        site_account_profile_country: 'Country/Region',
        site_account_profile_country_wrong_tip: 'Please Enter Country',
        site_account_profile_firstname_wrong_tip: 'Invalid first name',
        site_account_address_zip_wrong_tip: 'Invalid zip',
        site_account_profile_username_wrong_tip: 'Invalid username',
        site_account_address_company_website_wrong_tip: 'Invalid company website',
        site_account_address_phone_wrong_tip: 'Invalid phone',
        site_account_address_address_wrong_tip: 'Invalid address',
        site_account_address_company_name_wrong_tip: 'Invalid company name',
        site_account_profile_lastname_wrong_tip: 'Invalid last name',
        site_account_profile_country_select_wrong_tip: 'Please select your country!',
        site_account_address_adress: 'My Address',
        site_account_address_apt: 'Apt, Suite, Building(optional)',
        city_validatino_error: 'Invalid city',
        site_account_address_city: 'City',
        site_account_profile_email: 'Email Address',
        product_rules: 'For {product} only.',
        points: 'EcoCredits',
        redeem_now: 'REDEEM NOW',
        off: 'OFF',
        use_new_address: 'use a new address',
        stock_left: '{stock} Left',
        order_text: 'Order',
        site_account_profile_save_success: 'Success',
        grab_success_text2: 'Check your bonuses in <code>My Rewards</code>.',
        only_plus_member: 'Only PLUS Members can redeem the reward.',
        only_member: 'Only Members can redeem the reward.',
    },
    za: {
        discount: 'Discount',
        product_text: 'Product',
        gift_card: 'Gift Card',
        site_account_profile_firstname: 'First Name',
        site_account_profile_lastname: 'Last Name',
        site_account_address_zip: 'Zip',
        site_account_address_phone: 'Phone',
        view_all: 'View all',
        coupon: 'Discount code',
        have_points: 'You have <code>{points} EcoCredits</code>',
        available: 'Available',
        redeemed: 'Redeemed',
        expired: 'Expired',
        spend_now: 'Spend Now',
        store: 'Shop Now',
        no_enough_points: 'Redemption failed, your EcoCredits are not enough',
        no_history_note: 'Don’t see your EcoCredits yet? Your activity will update with in 24 hours.',
        no_coupon_note: 'No rewards redeemed yet.',
        stay_too_long: 'Your session has expired. Please refresh the page and try again.',
        exceeded_counts: 'Failed to redeem. You have exceeded the redemption limit.',
        minimum_num: 'Minimum quantity of items({num} pcs).',
        no_stock_tip: 'Coming soon... Stay tuned!',
        network_error: 'Network Error',
        redeem_ecocredits_title: 'Redeem EcoCredits Rewards',
        redeemed_succ: 'Redeemed successfully!',
        copy_desc: 'You have copied the code, please go to the store to use it.',
        copy_desc_2: 'You have copied the code.',
        rules: 'Rules',
        confirm_text: 'Are you sure you want to redeem? Cannot be undone.',
        confirm_btn: 'Confirm',
        site_rules: 'For ZA store only.',
        order_rule: 'Only one discount code per order.',
        purchas_rule: 'Purchasing an item for less than the coupon(s), will forfeit the difference.',
        minimum_price: 'Minimum purchase amount ({price}).',
        days_rules: 'Valid for {days} days from redemption.',
        days_rules2: 'Valid from {data}.',
        campaign_time_limit_text: 'Valid redemption period: {startTime} - {endTime}.',
        email_validation_error: 'Please enter a valid email address.',
        shipping_address_text: 'Shipping address',
        site_account_profile_country: 'Country/Region',
        site_account_profile_country_wrong_tip: 'Please Enter Country',
        site_account_profile_firstname_wrong_tip: 'Invalid first name',
        site_account_address_zip_wrong_tip: 'Invalid zip',
        site_account_profile_username_wrong_tip: 'Invalid username',
        site_account_address_company_website_wrong_tip: 'Invalid company website',
        site_account_address_phone_wrong_tip: 'Invalid phone',
        site_account_address_address_wrong_tip: 'Invalid address',
        site_account_address_company_name_wrong_tip: 'Invalid company name',
        site_account_profile_lastname_wrong_tip: 'Invalid last name',
        site_account_profile_country_select_wrong_tip: 'Please select your country!',
        site_account_address_adress: 'My Address',
        site_account_address_apt: 'Apt, Suite, Building(optional)',
        city_validatino_error: 'Invalid city',
        site_account_address_city: 'City',
        site_account_profile_email: 'Email Address',
        product_rules: 'For {product} only.',
        points: 'EcoCredits',
        redeem_now: 'REDEEM NOW',
        off: 'OFF',
        use_new_address: 'use a new address',
        stock_left: '{stock} Left',
        order_text: 'Order',
        site_account_profile_save_success: 'Success',
        grab_success_text2: 'Check your bonuses in <code>My Rewards</code>.',
        only_plus_member: 'Only PLUS Members can redeem the reward.',
        only_member: 'Only Members can redeem the reward.',
    },
    br: {
        discount: 'Desconto',
        product_text: 'Produto',
        gift_card: 'Vale-presente',
        site_account_profile_firstname: 'Nome',
        site_account_profile_lastname: 'Sobrenome',
        site_account_address_zip: 'Código postal',
        site_account_address_phone: 'Celular',
        view_all: 'Ver tudo',
        coupon: 'Código de desconto',
        have_points: 'Você tem <code>{points} EcoCredits</code>',
        available: 'Disponível',
        redeemed: 'Resgatados',
        expired: 'Expirados',
        spend_now: 'Gaste agora',
        store: 'Comprar agora',
        no_enough_points: 'Erro no resgate, não há EcoCredits suficientes',
        no_history_note: 'Ainda não está vendo seus EcoCredits? Sua atividade será atualizada em 24 horas.',
        no_coupon_note: 'Nenhuma recompensa resgatada ainda.',
        stay_too_long: 'Sua sessão expirou. Atualize a página e tente de novo.',
        exceeded_counts: 'Não foi possível o resgate. Você excedeu o limite de resgates.',
        minimum_num: 'Quantidade mínima de itens ({num} pçs).',
        no_stock_tip: 'Em breve… Fique de olho!',
        network_error: 'Erro de rede',
        redeem_ecocredits_title: 'Resgate recompensas com EcoCredits',
        redeemed_succ: 'Resgatados com sucesso!',
        copy_desc: 'Você já copiou o código. Vá até a loja para usá-lo.',
        copy_desc_2: 'Você copiou o código.',
        rules: 'Regras',
        confirm_text: 'Tem certeza de que deseja resgatar? Não pode ser desfeito.',
        confirm_btn: 'Confirmar',
        site_rules: 'Apenas para loja na BR.',
        order_rule: 'Apenas um código de desconto por pedido.',
        purchas_rule: 'Comprar um item por menos que o(s) cupom(ns) cancelará a diferença.',
        minimum_price: 'Valor mínimo de compra ({price}).',
        days_rules: 'Válido por {days} dias a partir do resgate.',
        days_rules2: 'Válido a partir de {data}.',
        campaign_time_limit_text: 'Período de resgate válido entre {startTime} e {endTime}.',
        email_validation_error: 'Insira um endereço de e-mail válido.',
        shipping_address_text: 'Endereço de envio',
        site_account_profile_country: 'País/Região',
        site_account_profile_country_wrong_tip: 'Insira o país',
        site_account_profile_firstname_wrong_tip: 'Nome inválido',
        site_account_address_zip_wrong_tip: 'Código postal inválido',
        site_account_profile_username_wrong_tip: 'Nome de usuário inválido',
        site_account_address_company_website_wrong_tip: 'Site da empresa inválido',
        site_account_address_phone_wrong_tip: 'Telefone inválido',
        site_account_address_address_wrong_tip: 'Endereço inválido',
        site_account_address_company_name_wrong_tip: 'Nome da empresa inválido',
        site_account_profile_lastname_wrong_tip: 'Sobrenome inválido',
        site_account_profile_country_select_wrong_tip: 'Selecione seu país!',
        site_account_address_adress: 'Endereço',
        site_account_address_apt: 'Apartamento, conjunto, prédio (opcional)',
        city_validatino_error: 'Cidade inválida',
        site_account_address_city: 'Cidade',
        site_account_profile_email: 'Endereço de e-mail',
        product_rules: 'Apenas para {product}.',
        points: 'EcoCredits',
        redeem_now: 'RESGATE AGORA',
        off: 'DESCONTO',
        use_new_address: 'use um novo endereço',
        stock_left: '{stock} restante',
        order_text: 'Pedido',
        site_account_profile_save_success: 'Sucesso',
        grab_success_text2: 'Veja seus bônus em <code>Minhas recompensas</code>.',
        only_plus_member: 'Somente Membros PLUS podem resgatar a recompensa.',
        only_member: 'Somente Membros podem resgatar a recompensa.',
    },
    mx: {
        discount: 'Descuento',
        product_text: 'Producto',
        gift_card: 'Tarjetas de regalo',
        site_account_profile_firstname: 'Nombre',
        site_account_profile_lastname: 'Apellido',
        site_account_address_zip: 'Código postal',
        site_account_address_phone: 'Teléfono',
        view_all: 'Ver todo',
        coupon: 'Código de descuento',
        have_points: 'Tiene <code>{points} EcoCredits</code>',
        available: 'Disponible',
        redeemed: 'Canjeado',
        expired: 'Caducado',
        spend_now: 'Gastar ahora',
        store: 'Comprar ahora',
        no_enough_points: 'Error de canje, sus EcoCredits no son suficientes',
        no_history_note: '¿Todavía no ve sus EcoCredits? Su actividad se actualizará en 24 horas.',
        no_coupon_note: 'Aún no se ha canjeado ninguna recompensa.',
        stay_too_long: 'Su sesión ha expirado. Actualice la página e inténtelo de nuevo.',
        exceeded_counts: 'No se pudo canjear. Ha superado el límite de canje.',
        minimum_num: 'Cantidad mínima de artículos({num} uds.).',
        no_stock_tip: 'Próximamente… Esté atento.',
        network_error: 'Error de red',
        redeem_ecocredits_title: 'Canjear recompensas de EcoCredits',
        redeemed_succ: 'Canjeado correctamente',
        copy_desc: 'Copió el código. Vaya a la tienda para usarlo.',
        copy_desc_2: 'Ha copiado el código.',
        rules: 'Reglas',
        confirm_text: '¿Está seguro de que desea canjear? No se puede deshacer.',
        confirm_btn: 'Confirmar',
        site_rules: 'Solo para tienda de MX.',
        order_rule: 'Solo un código de descuento por pedido.',
        purchas_rule: 'Si compra un artículo por un precio inferior al del cupón, perderá la diferencia.',
        minimum_price: 'Importe mínimo de compra ({price}).',
        days_rules: 'Válido durante {days} días a partir del canje.',
        days_rules2: 'Válido a partir de {data}.',
        campaign_time_limit_text: 'Período de canje válido: {startTime} - {endTime}.',
        email_validation_error: 'Ingresa una dirección de correo electrónico válida.',
        shipping_address_text: 'Dirección de envío',
        site_account_profile_country: 'País/Región',
        site_account_profile_country_wrong_tip: 'Ingrese el país',
        site_account_profile_firstname_wrong_tip: 'Nombre no válido',
        site_account_address_zip_wrong_tip: 'Código postal no válida',
        site_account_profile_username_wrong_tip: 'Nombre de usuario no válido',
        site_account_address_company_website_wrong_tip: 'Sitio web de la empresa no válido',
        site_account_address_phone_wrong_tip: 'Teléfono no válido',
        site_account_address_address_wrong_tip: 'Dirección no válida',
        site_account_address_company_name_wrong_tip: 'Nombre de empresa no válido',
        site_account_profile_lastname_wrong_tip: 'Apellido no válido',
        site_account_profile_country_select_wrong_tip: 'Seleccione su país',
        site_account_address_adress: 'Dirección',
        site_account_address_apt: 'Departamento, oficina, edificio (opcional)',
        city_validatino_error: 'Ciudad no válida',
        site_account_address_city: 'Ciudad',
        site_account_profile_email: 'Dirección de correo electrónico',
        product_rules: 'Solo para {product}.',
        points: 'EcoCredits',
        redeem_now: 'CANJEAR AHORA',
        off: 'DE DESCUENTO',
        use_new_address: 'utilizar una nueva dirección',
        stock_left: '{stock} restante',
        order_text: 'Pedido',
        site_account_profile_save_success: 'Éxito',
        grab_success_text2: 'Revise sus bonos en <code>Mis Recompensas</code>.',
        only_plus_member: 'Solo los miembros PLUS pueden canjear la recompensa.',
        only_member: 'Solo los miembros pueden canjear la recompensa.',
    },
    ph: {
        discount: 'Discount',
        site_account_profile_firstname: 'First Name',
        site_account_profile_lastname: 'Last Name',
        site_account_address_zip: 'Zip',
        site_account_address_phone: 'Phone',
        product_text: 'Product',
        gift_card: 'Gift Card',
        view_all: 'View all',
        coupon: 'Discount code',
        have_points: 'You have <code>{points} EcoCredits</code>',
        available: 'Available',
        redeemed: 'Redeemed',
        expired: 'Expired',
        spend_now: 'Spend Now',
        store: 'Shop Now',
        no_enough_points: 'Redemption failed, your EcoCredits are not enough',
        no_history_note: 'Don’t see your EcoCredits yet? Your activity will update with in 24 hours.',
        no_coupon_note: 'No rewards redeemed yet.',
        stay_too_long: 'Your session has expired. Please refresh the page and try again.',
        exceeded_counts: 'Failed to redeem. You have exceeded the redemption limit.',
        minimum_num: 'Minimum quantity of items({num} pcs).',
        no_stock_tip: 'Coming soon... Stay tuned!',
        network_error: 'Network Error',
        redeem_ecocredits_title: 'Redeem EcoCredits Rewards',
        redeemed_succ: 'Redeemed successfully!',
        copy_desc: 'You have copied the code, please go to the store to use it.',
        copy_desc_2: 'You have copied the code.',
        rules: 'Rules',
        confirm_text: 'Are you sure you want to redeem? Cannot be undone.',
        confirm_btn: 'Confirm',
        site_rules: 'For PH store only.',
        order_rule: 'Only one discount code per order.',
        purchas_rule: 'Purchasing an item for less than the coupon(s), will forfeit the difference.',
        minimum_price: 'Minimum purchase amount ({price}).',
        days_rules: 'Valid for {days} days from redemption.',
        days_rules2: 'Valid from {data}.',
        campaign_time_limit_text: 'Valid redemption period: {startTime} - {endTime}.',
        email_validation_error: 'Please enter a valid email address.',
        shipping_address_text: 'Shipping address',
        site_account_profile_country: 'Country/Region',
        site_account_profile_country_wrong_tip: 'Please Enter Country',
        site_account_profile_firstname_wrong_tip: 'Invalid first name',
        site_account_address_zip_wrong_tip: 'Invalid zip',
        site_account_profile_username_wrong_tip: 'Invalid username',
        site_account_address_company_website_wrong_tip: 'Invalid company website',
        site_account_address_phone_wrong_tip: 'Invalid phone',
        site_account_address_address_wrong_tip: 'Invalid address',
        site_account_address_company_name_wrong_tip: 'Invalid company name',
        site_account_profile_lastname_wrong_tip: 'Invalid last name',
        site_account_profile_country_select_wrong_tip: 'Please select your country!',
        site_account_address_adress: 'My Address',
        site_account_address_apt: 'Apt, Suite, Building(optional)',
        city_validatino_error: 'Invalid city',
        site_account_address_city: 'City',
        site_account_profile_email: 'Email Address',
        product_rules: 'For {product} only.',
        points: 'EcoCredits',
        redeem_now: 'REDEEM NOW',
        off: 'OFF',
        use_new_address: 'use a new address',
        stock_left: '{stock} Left',
        order_text: 'Order',
        site_account_profile_save_success: 'Success',
        grab_success_text2: 'Check your bonuses in <code>My Rewards</code>.',
        only_plus_member: 'Only PLUS Members can redeem the reward.',
        only_member: 'Only Members can redeem the reward.',
    },
};

export default langText;
